import React from 'react';
import './Experience.css';

const Experience: React.FC = () => {
  const experiences = [
    {
      title: "Technical Manager",
      company: "Repzo Inc.",
      period: "May 2025 - Present",
      location: "Amman, Jordan (Hybrid)",
      description: [
        "End-to-end engineering leadership: Own Back-End and DevOps strategy while overseeing Design, QA, and Project Management leads",
        "AI transformation owner: Lead company-wide AI adoption with computer-vision pipelines (object detection, OCR) and LangChain-based agents",
        "Architecture & delivery excellence: Define scalable cloud architectures (AWS), enforce coding standards, and institute CI/CD best practices",
        "People & process: Mentor multi-disciplinary teams, introduce outcome-oriented OKRs, and refine agile workflows",
        "Innovation & partnership: Evaluate ML models, open-source tools, and vendor solutions to enhance customer value"
      ]
    },
    {
      title: "Sr. Back End Developer",
      company: "Repzo Inc.",
      period: "Sep 2019 - May 2025",
      location: "Amman, Jordan",
      description: [
        "Developed and scaled robust back-end systems using Node.js, TypeScript, Express, and FeathersJS",
        "Managed MongoDB Cloud Atlas with advanced schemas, indexing, aggregations, and auto-scaling",
        "Implemented Realm-sync and Elasticsearch for enhanced data management and search capabilities",
        "Integrated various SMS gateways and messaging systems using RabbitMQ (AMQP)",
        "Optimized AWS services: S3, EC2, VPC, ELB, Lambda, API Gateway, SQS, SES, CloudWatch, DynamoDB, ElastiCache",
        "Built DevOps pipelines with CodeBuild, CodePipeline, and CloudFormation for automated deployments"
      ]
    },
    {
      title: "Sr. Project Engineer",
      company: "International Buildings System Factory",
      period: "Apr 2017 - Sep 2019",
      location: "Saudi Arabia",
      description: [
        "Worked closely with sales and contracts department to secure major projects",
        "Proposed engineering approaches and analyzed relevant cost effects for management",
        "Provided technical solutions and attended customer negotiations and technical meetings",
        "Supported sales teams with engineering expertise to close critical deals"
      ]
    },
    {
      title: "Project Engineer",
      company: "BCOMS / Zamil Steel Holding",
      period: "Mar 2012 - Apr 2017",
      location: "Jeddah, Saudi Arabia",
      description: [
        "Managed structural steel projects and engineering solutions",
        "Coordinated with international teams for project delivery",
        "Developed technical specifications and project documentation"
      ]
    }
  ];

  return (
    <section id="experience" className="experience">
      <div className="container">
        <h2>Experience</h2>
        <div className="timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-marker"></div>
              <div className="timeline-content">
                <div className="experience-header">
                  <h3>{exp.title}</h3>
                  <div className="company-info">
                    <h4>{exp.company}</h4>
                    <span className="period">{exp.period}</span>
                    <span className="location">{exp.location}</span>
                  </div>
                </div>
                <ul className="experience-description">
                  {exp.description.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
